import qs from 'qs';
import AxiosInstanceCreator from 'services/api';
import {
  INation,
  ReqCreateNation,
  ReqNations,
  ReqUpdateNation,
  ResNations
} from '../models/nation.model';
import { BaseApiResponse, ResultBaseProps } from 'modules/common';
import { AxiosInstance } from 'axios';

const nationInstance = new AxiosInstanceCreator().create();

export const nationApi = {
  /**
   * 국가 목록 조회
   * @param {{page:number, size:number}} [data]
   * @returns
   */
  async getNations(): Promise<ResNations> {
    return nationInstance
      .get(`/nation?${qs.stringify({ page: 0, size: 999 })}`)
      .then((res) => res.data);
  },

  /**
   * 국가 save
   * @param {{countryName,countryCode,numberCode}} [data]
   * @returns
   */
  async createNation(data: ReqCreateNation): Promise<ResultBaseProps> {
    return nationInstance.post('/nation', data).then((res) => res.data);
  },

  /**
   * 국가 Edit
   * @param {{nationId,countryName,countryCode,numberCode}} [data]
   * @returns
   */
  async updateNation(data: ReqUpdateNation): Promise<ResultBaseProps> {
    return nationInstance.put('/nation', data).then((res) => res.data);
  },

  /**
   * 국가 삭제
   * @param {{nationId}} id
   * @returns
   */
  async deleteNation(nationId: string): Promise<ResultBaseProps> {
    return nationInstance.delete(`/nation/${nationId}`).then((res) => res.data);
  }
};

export class NationAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator({}).create();
  }

  /** 국가 목록 조회 API */
  async getNationList(params: ReqNations): Promise<BaseApiResponse<unknown, INation>> {
    return nationInstance
      .get<BaseApiResponse<unknown, INation>>(`/nation`, { params })
      .then((res) => res.data);
  }
}
